import * as React from 'react';
import { Grid, StyledComponentProps, Radio, RadioGroup, FormControlLabel } from '@material-ui/core';
import TextField from '../../../ui-components/TextField/TextField';
import NewItemButton from '../../../ui-components/Button/NewItemButton';
import Button from '../../../ui-components/Button/Button';
import { Select, SelectItem } from '../../../ui-components/select/Select';
import { SUBSCRIPTIONTYPES } from '../../../model/subscription';
// import { SearchBoxApi } from '../../../ui-components/SearchBoxApi/SearchBoxApi';
// import { contact } from '../../../model/contact';
// import { invokeApi } from '../../../common/networking/invoker';

interface IProps extends StyledComponentProps {
    handleFilterChange: (val: string) => void;
    textSearch?: string;
    search: (text?: string, subscriptionType?: any, state?: string) => void;
    new: () => void;
    loading: boolean;
}

export const Filters = (props: IProps) => {
    const [selectedtItem, setSelectedtItem] = React.useState<SelectItem>();
    const [selectedtState, setSelectedtState] = React.useState<string>("attivi");
    // const [selectedDays, setSelectedDays] = React.useState<subscriptionRules>(props.subscription?.subscriptionRules);
    // export const Filters = (props: IProps) =>
    // let contact: contact;
    
    const classes = props.classes;
    const setSubscriptionType = (item) => {
        if (item !== undefined) {
            // var i = { name: SUBSCRIPTIONTYPES[item].title, value: item }
            setSelectedtItem(item);
        }
    }
    // const translateState = (state: string) => {
    //     console.log("------------------------------setSubscriptionType");
    //     console.log(state);
    //     // if (state === undefined)
    //     //     return "all";
    //     // if (state === ActivityState.approved)
    //     //     return 'approved';
    //     // if (state === ActivityState.draft)
    //     //     return 'draft';
    //     setSelectedtState(state);
    //     return state;
    // }

    const subscriptionTypes = Object.keys(SUBSCRIPTIONTYPES);
    return (
        <Grid container className={classes.root} spacing={2}>
            <Grid item sm={3} >
                <TextField label='Nome Abbonamento'
                    onKeyDown={(e) => {
                        //Enter KeyCode = 13
                        if (e.keyCode === 13) {
                            props.search(props.textSearch, selectedtItem?.value, selectedtState) 
                        }
                    }}
                    disabled={props.loading} 
                    onChange={props.handleFilterChange} 
                    value={props.textSearch} />
            </Grid>
            <Grid item sm={3} style={{margin: 'auto'}}>
                <Select fullWidth
                    selected={selectedtItem ? selectedtItem : { name: '', value: '' }}
                    items={subscriptionTypes.map(t => {
                        return { name: SUBSCRIPTIONTYPES[t].title, value: t }
                    })}
                    onChange={(item) => { setSubscriptionType(item); props.search(props.textSearch, selectedtItem?.value, selectedtState); }} label='Seleziona un tipo' />
            </Grid>
            <Grid item sm={3} style={{ display: 'flex', alignItems: 'center' }}>
                {/* <FormLabel component="legend" style={{ marginRight: 10 }}>Stato: </FormLabel> */}
                <RadioGroup style={{ display: 'flex', flexDirection: 'row' }} aria-label="filter" name="filter" value={selectedtState} onChange={event => { setSelectedtState(event.target.value); props.search(props.textSearch, selectedtItem?.value, event.target.value); }}>
                    <FormControlLabel value={"attivi"} control={<Radio />} label="Attivi" />
                    <FormControlLabel value={"scaduti"} control={<Radio />} label="Scaduti" />
                </RadioGroup>
            </Grid>
            <Grid item sm={1} className={classes.searchButtons} >
                <div className={classes.searchButton}>
                    <Button className={classes.searchButton} onClick={() => props.search(props.textSearch, selectedtItem?.value, selectedtState)}>Cerca</Button>
                </div>
            </Grid>
            <Grid item sm={1} className={classes.searchButtons} >
                <div className={classes.searchButton}>
                    <NewItemButton disabled={props.loading} onClick={() => props.new()} text="Nuovo" />
                </div>
            </Grid>
        </Grid>
    );
}
